module.exports = __webpack_public_path__ + "img/chevron-back-outline-grey.76b1231a.svg";